import { registerPlugin } from '@capacitor/core';
import type { ParentHubCalendarPlugin } from './definitions';

const ParentHubCalendar = registerPlugin<ParentHubCalendarPlugin>('ParentHubCalendar');

export * from './definitions';
export { ParentHubCalendar };
